export default __webpack_public_path__ + "static/media/school.80d94a37.svg";